import React, { useRef, useState, useEffect } from "react";
import { CardHeader, Container, Button, Badge } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

const NoDataIndication = () => (
  <div
    style={{
      padding: "20px",
      textAlign: "center",
      color: "#6c757d",
      fontSize: "14px",
      fontWeight: "bold",
    }}
  >
    0 Records Found
  </div>
);

const ReactPlainTable = ({
  title,
  description,
  data,
  columns,
  keyField,
  showActions = false,
  addbtntext,
  onAddBtnClick,
  expandRow,
  showAddbtn = true,
  handleRowClick,
  renderFilters,
  page = 1,
  totalRecords = 0,
  onPageChange,
  onSortChange,
  defaultSortField = "",
  defaultSortOrder = "",
  staticInfoHeading = "",
  showLoader = false,
  Columnstext = "",
  showColumnsBtn,
  toggleColumnsModal,
  ExportCSVtext = "",
  exportCSVBtnShow = false,
  onexportCsvBtnClick,
  showAdminPerformanceHeading = false,
  enablePagination = true,
  enablePageSizeManagement = false,
  handleSizePerPageChange,
  sizePerPage=50

}) => {
  const componentRef = useRef(null);

  const [currentSizePerPage, setCurrentSizePerPage] =
    useState(sizePerPage);
  const [currentPage, setCurrentPage] = useState(page);



  useEffect(() => {
    setCurrentPage(page);
  }, [page]);

    useEffect(() => {
    setCurrentSizePerPage(sizePerPage);
  }, [sizePerPage]);

  const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    if (type === "pagination") {
      setCurrentPage(page);
      onPageChange && onPageChange(page, sizePerPage);
    }

    if (type === "sort") {
      onSortChange && onSortChange(sortField, sortOrder);
    }
  };

  const paginationOptions = paginationFactory({
    page: enablePageSizeManagement ? currentPage : page,
    sizePerPage: enablePageSizeManagement
      ? currentSizePerPage
      : sizePerPage,
    totalSize: totalRecords,
    hideSizePerPage: true,
    showTotal: true,
    withFirstAndLast: false,
    paginationTotalRenderer: (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total ml-3 ">
        Results <b>{from}</b>–<b>{to}</b> out of <b>{size}</b> records
      </span>
    ),
    pageButtonRenderer: ({ page, active, onPageChange }) => (
      <li key={page} className="page-item">
        <button
          className="page-link"
          style={{
            backgroundColor: active ? "#D8534C" : "white",
            color: active ? "white" : "#D8534C",
            borderColor: "#D8534C",
          }}
          onClick={(e) => {
            e.preventDefault();
            onPageChange(page);
          }}
        >
          {page}
        </button>
      </li>
    ),
  });

  return (
    <>
      
        <div>
          <h3 className="mb-0">{title}</h3>
          <p className="text-sm mb-0">{description}</p>
          <p className="text-sm mb-0 text-danger">
            {staticInfoHeading}
          </p>

          {showAdminPerformanceHeading && (
            <div>
              <small className="text-muted">
                Report Type: <Badge color="info">Processed</Badge> |
                View By: <Badge color="primary">DATE</Badge> 
        
              </small>
            </div>
          )}
        </div>

        <div className="d-flex align-items-center">
          {showAddbtn && (
            <Button
              className="btn-gradient-primary btn-sm"
              onClick={onAddBtnClick}
            >
              <i className="fa fa-plus mr-1" />
              {addbtntext}
            </Button>
          )}

          {exportCSVBtnShow && (
            <Button
              color="success"
              size="sm"
              onClick={onexportCsvBtnClick}
            >
              <i className="ni ni-cloud-download-95 mr-1" />
              {ExportCSVtext}
            </Button>
          )}

          {showColumnsBtn && (
            <Button
              className="btn-gradient-primary" 
              size="sm"
              onClick={toggleColumnsModal}
            >
              <i className="ni ni-bullet-list-67 mr-1" />
              {Columnstext}
            </Button>
          )}
        </div>
    

      {renderFilters && (
        <Container fluid className="py-3">
          {renderFilters()}
        </Container>
      )}

      <ToolkitProvider data={data} keyField={keyField} columns={columns}>
        {(props) => (
          <div className="py-4 table-scroll-wrapper">
            {showLoader ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "100px" }}
              >
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ fontSize: "25px" }}
                />
              </div>
            ) : (
              <>
               
                  <BootstrapTable
                    className="table-alternate-spaced text-center"
                    ref={componentRef}
                    {...props.baseProps}
                    remote={{ filter: false, pagination: enablePagination, sort: true }}
                    onTableChange={handleTableChange}
                    defaultSorted={defaultSortField ? [{ dataField: defaultSortField, order: defaultSortOrder }] : []}
                    pagination={
                      enablePagination ? paginationOptions : false
                    }
                    expandRow={expandRow}
                    noDataIndication={() => <NoDataIndication />}
                    bordered={false}
                    rowEvents={{
                      onClick: (e, row, rowIndex) => {
                        handleRowClick &&
                          handleRowClick(row, rowIndex, e);
                      },
                    }}
                    id="react-bs-table"
                  />
              

                {/* Page Size Selector OUTSIDE pagination prop */}
                {enablePagination && enablePageSizeManagement && (
                  <div
                    style={{
                      padding: "10px 15px",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        marginRight: "10px",
                        fontSize: "14px",
                        color: "#6c757d",
                     
                      }}
                    >
                      Rows per page:
                    </span>

                    <select
                      value={currentSizePerPage}
                      onChange={handleSizePerPageChange}
                      style={{
                        padding: "5px 10px",
                        borderRadius: "4px",
                        border: "1px solid #dee2e6",
                        fontSize: "14px",
                      }}
                    >
         
                      {[25, 50, 75, 100, 200, 500].map((size) => (
                        <option key={size} value={size}>
                         {size}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </>
            )}

            {!enablePagination && (
              <div className="px-3 pb-2 text-muted">
                Total Records: <b>{totalRecords}</b>
              </div>
            )}
          </div>
        )}
      </ToolkitProvider>
    </>
  );
};

export default ReactPlainTable;